export default __webpack_public_path__ + "static/media/hippo_standup.95fbb8f9.png";